import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import getBusinessName from "../common/Business";
import Address from "./Address";
import { getDate } from "../common/DisplayDate";
import getPhone from "../common/Phone";

class PeopleAtWorkRecordDetail extends Component {
  componentDidMount() {}

  render() {
    const results = [];
    const { node } = this.props;
    if (node !== undefined && node !== null) {
      const employers = _.get(node, "employers[0].employer");
      if (employers !== undefined) {
        _.forEach(employers, (employer, index) => {
          const companyNames = [];
          _.forEach(
            _.get(employer, "companyNames[0].companyName"),
            (companyName, compIndex) => {
              companyNames.push(
                <span key={`PatW_Record_Comp_Name_Row_${index}_${compIndex}`}>
                  {getBusinessName(_.get(companyName, "_", ""), this.props)}
                  <br />
                </span>
              );
            }
          );
          const addresses = [];
          _.forEach(
            _.get(employer, "addresses[0].address"),
            (address, addressIndex) => {
              addresses.push(
                <span key={`peo_span_${addressIndex}`}>
                  <Address
                    key={`PatW_Record_Address_Row_${index}_${addressIndex}`}
                    addressNode={address}
                    {...this.props}
                  />
                  <br />
                </span>
              );
            }
          );
          const companyRows = [];
          companyRows.push(
            <Table.Row key={`PatW_Record_Com_Row_${index}`}>
              <Table.Cell>Company Name:</Table.Cell>
              <Table.Cell>{companyNames}</Table.Cell>
              <Table.Cell>Address:</Table.Cell>
              <Table.Cell>{addresses}</Table.Cell>
            </Table.Row>
          );
          const employmentDates = `${getDate(
            _.get(employer, "datesSeen[0].dateSeen[0].dateFirstSeen[0]")
          )} - ${getDate(
            _.get(employer, "datesSeen[0].dateSeen[0].dateLastSeen[0]"),
            "DOB"
          )}`;
          companyRows.push(
            <Table.Row key={`PatW_Record_Phone_Row_${index}`}>
              <Table.Cell>Employment Dates:</Table.Cell>
              <Table.Cell>{employmentDates}</Table.Cell>
              <Table.Cell>Phone:</Table.Cell>
              <Table.Cell>
                {getPhone(
                  _.get(
                    employer,
                    "addresses[0].address[0].phones[0].phone[0].phone10[0]._",
                    ""
                  ),
                  this.props
                )}
              </Table.Cell>
            </Table.Row>
          );
          _.forEach(
            _.get(employer, "positions[0].position"),
            (position, posIndex) => {
              const posEmploymentDates = `${getDate(
                _.get(position, "datesSeen[0].dateSeen[0].dateFirstSeen[0]")
              )} - ${getDate(
                _.get(position, "datesSeen[0].dateSeen[0].dateLastSeen[0]")
              )}`;
              companyRows.push(
                <Table.Row key={`PatW_Record_Pos_Row_${index}_${posIndex}`}>
                  <Table.Cell>Employment Dates:</Table.Cell>
                  <Table.Cell>{posEmploymentDates}</Table.Cell>
                  <Table.Cell>Position:</Table.Cell>
                  <Table.Cell>{_.get(position, "title[0]._", "")}</Table.Cell>
                </Table.Row>
              );
            }
          );
          results.push(
            <Table.Row key={`PatW_Comp_table_Record_Com_Row_${index}`}>
              <Table.Cell colSpan={4}>
                <Table>
                  <Table.Body>{companyRows}</Table.Body>
                </Table>
              </Table.Cell>
            </Table.Row>
          );
        });
      }
    }

    return (
      <Table>
        <Table.Body>{results}</Table.Body>
      </Table>
    );
  }
}

export default PeopleAtWorkRecordDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/PeopleAtWorkRecordDetail.js